import { render, staticRenderFns } from "./DownloadAppNotif.vue?vue&type=template&id=6d5ca88e&"
import script from "./DownloadAppNotif.vue?vue&type=script&lang=js&"
export * from "./DownloadAppNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports